'use client';

import { useEffect } from 'react';
import { useAuth } from '../lib/auth';
import { installErrorLogger } from '../lib/errorLogger';

/**
 * Installs global error handlers on mount and updates the current user email
 * so errors include who experienced them.
 */
export default function ErrorLoggerInit() {
  const { email } = useAuth();

  useEffect(() => {
    installErrorLogger();
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      (window as any).__userEmail = email;
    }
  }, [email]);

  return null;
}
